module.exports = __webpack_public_path__ + "static/img/appDownload.d36c6b45.png";